/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface NewModel
 */
export interface NewModel {
  /**
   *
   * @type {string}
   * @memberof NewModel
   */
  uuid: string;
}

/**
 * Check if a given object implements the NewModel interface.
 */
export function instanceOfNewModel(value: object): value is NewModel {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  return true;
}

export function NewModelFromJSON(json: any): NewModel {
  return NewModelFromJSONTyped(json, false);
}

export function NewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewModel {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid']
  };
}

export function NewModelToJSON(value?: NewModel | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid']
  };
}
